import { createContext, useContext } from "react";
import { IContext } from "./types";

const initialState = {
  entityFilters: [],
  loading: true
};
const FiltersContext = createContext<IContext>(initialState);

const useFilters = () => useContext(FiltersContext);

export { FiltersContext, useFilters };
